import PropTypes from 'prop-types';
const SVGComponent =({ fill = '#FAFAFA', ...props })  => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_4029_3279"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect x={0.5} width={16} height={16} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4029_3279)">
      <path
        d="M11.9995 12H15.1662V13.3333H10.6662L11.9995 12ZM3.66618 13.3333L2.24951 11.9167C1.99395 11.6611 1.8634 11.3444 1.85784 10.9667C1.85229 10.5889 1.97729 10.2667 2.23284 10L9.56618 2.4C9.82173 2.13333 10.1356 2 10.5078 2C10.8801 2 11.194 2.12778 11.4495 2.38333L14.7662 5.7C15.0217 5.95556 15.1495 6.27222 15.1495 6.65C15.1495 7.02778 15.0217 7.34444 14.7662 7.6L9.16618 13.3333H3.66618ZM8.59951 12L13.8328 6.63333L10.5328 3.33333L3.16618 10.9333L4.23284 12H8.59951Z"
        fill={fill}
      />
    </g>
  </svg>
);

SVGComponent.propTypes = {
  fill: PropTypes.string,
};


export default SVGComponent;
